import { render } from "./CommonBanner.vue?vue&type=template&id=36bbd74f"
import script from "./CommonBanner.vue?vue&type=script&lang=js"
export * from "./CommonBanner.vue?vue&type=script&lang=js"

import "./CommonBanner.vue?vue&type=style&index=0&id=36bbd74f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__